import moment from 'moment';

import * as TYPES from './actions/types';

export const initialState = {
  healthSummaryHtml: null,
  currentIdentifier: null,
  downloadPath: null,
  filteredCcdas: [],
  options: {
    startDate: moment().subtract(1, 'years').format('l'),
    endDate: moment().format('l'),
    selectedExternalSystem: null,
    radioValue: 'daterange',
    selectedVisitIdentifier: null,
  },
  recentVisits: [],
};

const healthSummaryReducer = (state = initialState, action) => {
  let newState;

  switch (action.type) {
    case TYPES.OPTIONS_SELECTED:
      newState = { ...state, ...action.state };
      break;
    case TYPES.HEALTH_SUMMARY_LIST_LOADED:
      newState = { ...state, ...action.state };
      break;
    case TYPES.HEALTH_SUMMARY_LIST_LOAD_FAILED:
      newState = { ...state, ...initialState, ...action.state };
      break;
    case TYPES.HEALTH_SUMMARY_HTML_LOADED_SUCCESS:
      newState = { ...state, ...action.state };
      break;
    case TYPES.HEALTH_SUMMARY_HTML_LOADED_FAILED:
      newState = { ...state, ...initialState, ...action.state };
      break;
    case TYPES.MOST_RECENT_HEALTH_SUMMARY_LOADED_SUCCESS:
      newState = { ...state, ...action.state };
      break;
    case TYPES.MOST_RECENT_HEALTH_SUMMARY_LOADED_FAILED:
      newState = { ...state, ...action.state };
      break;
    case TYPES.HEALTH_SUMMARY_SET_DOWNLOAD_PATH:
      newState = { ...state, ...action.state };
      break;
    case TYPES.HEALTH_SUMMARY_CLEAR_LOADED_HTML:
      newState = { ...state, ...initialState };
      break;
    case TYPES.RECENT_OFFICE_VISITS_LOADED_SUCCESS:
      newState = { ...state, ...action.state };
      break;
    case TYPES.RECENT_OFFICE_VISITS_LOADED_FAILED:
      newState = { ...state, ...action.state };
      break;
    case TYPES.HEALTH_SUMMARY_IDENTIFIER_UPDATE:
      newState = { ...state, ...action.state };
      break;
    default:
      newState = state;
  }

  return newState;
};

export default healthSummaryReducer;
